import { Card, Grid, Icon, Menu, Message, Table } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { useEffect } from 'react';
import * as actions from '../../../redux/actions';
import PageContainer from '../../common/PageContainer';
import * as selectors from '../../../redux/selectors';
import { bindActionCreators } from 'redux';
import AddFirmModal from './AddFirmModal';
import FirmSearchForm from './FirmSearchForm';
import './Firm.scss';

const FirmSearchPage = ({ history, getFirms, firms }) => {
  useEffect(() => {
    getFirms();
  }, []);

  return (
    <PageContainer>
      <Menu borderless>
        <Menu.Item header>
          <Icon name="building outline" />
          Firms
        </Menu.Item>
        <Menu.Menu position="right">
          <Menu.Item header>
            <AddFirmModal />
          </Menu.Item>
        </Menu.Menu>
      </Menu>

      {Boolean(firms) && (
        <Grid>
          <Grid.Column computer="13">
            <Table selectable compact="very" size="small">
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>Name</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {Object.keys(firms).map(key => (
                  <Table.Row key={firms[key].id} onClick={() => history.push('/firm/' + firms[key].id)}>
                    <Table.Cell>{firms[key].name}</Table.Cell>
                  </Table.Row>
                ))}
              </Table.Body>
            </Table>
            {Boolean(!firms || !Object.keys(firms).length) && <Message content="No records found" />}
          </Grid.Column>
          <Grid.Column computer="3">
            <Card fluid>
              <Card.Content>
                <FirmSearchForm />
              </Card.Content>
            </Card>
          </Grid.Column>
        </Grid>
      )}
    </PageContainer>
  );
};

const mapStateToProps = state => ({
  firms: selectors.getFirms(state),
});

const mapDispatchToProps = dispatch => ({
  getFirms: bindActionCreators(actions.firm.getFirms, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(FirmSearchPage);
